export interface Product {
  id?: number;
  type: ProductTypes;
  name: string;
  name_public?: string;
  public: boolean | number;
  price: number;
  unit: ProductUnitTypes;
  bediengeld?: number;
  tax: ProductTaxTypes;
  amount?: number;
  pivot?: ProductDayPivot;
}

export interface ProductDayPivot {
  day_id: number;
  product_id: number;
  amount: number;
}

export interface ProductSyncItem {
  id: number;
  amount: number;
}

export interface ProductsSync {
  products: ProductSyncItem[];
}

export interface ProductIdsSync {
  product_ids: number[];
}

export type ProductTypes = 'drinks' | 'food' | 'voucher' | 'other';
export const ProductTypesMapper: Record<ProductTypes, string> = {
  drinks: 'Getränke',
  food: 'Essen',
  voucher: 'Gutschein',
  other: 'Sonstiges',
};

export type ProductUnitTypes = '0.2l' | '0.3l' | '1l' | '1piece' | 'none';
export const ProductUnitTypesMapper: Record<ProductUnitTypes, string> = {
  '0.2l': '0,2 Liter',
  '0.3l': '0,3 Liter',
  '1l': '1 Liter',
  '1piece': '1 Stück',
  none: '-',
};

export type ProductTaxTypes = 0 | 7 | 19 | 'none';
export const ProductTaxTypesMapper: Record<ProductTaxTypes, string> = {
  0: '0%',
  7: '7%',
  19: '19%',
  none: '-',
};
